import { useStore } from 'dg-web-shared/lib/Flux.tsx';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';
import { Translation } from '../../../common/i18n/Text.ts';
import {
    HalfSlideIn,
    SlideInBody,
    StandardFirstLevelHeader,
} from '../../../ui/slidein/Slidein.tsx';
import { filteredPermitsFilterHalfSlideInTexts } from '../../i18n/FilteredPermitsTexts.ts';
import * as FilteredPermitsState from '../../state/FilteredPermitsState.ts';
import { CostFilterSelection } from './CostFilter.tsx';
import { IssueDateFilterSelection } from './IssueDateFilter.tsx';
import { OperatorLoginFilterSelection } from './OperatorLoginFilter.tsx';
import { PermitTypeFilterSelection } from './PermitTypeFilter.tsx';
import { TimeLimitFilterSelection } from './TimeLimitFilter.tsx';
import { StatusFilterSelection } from './StatusFilter.tsx';
import { ValidDateFilterSelection } from './ValidDateFilter.tsx';
import { ChannelFilterSelection } from './ChannelFilter.tsx';

export interface FilteredPermitsFilterHalfSlideInTexts {
    title: Translation;
}

export function FilteredPermitsFilterHalfSlideIn() {
    const { storeState, update } = useStore(store => ({
        filter: FilteredPermitsState.Filter.get(store),
    }));
    const { language } = useLanguage();

    return (
        <HalfSlideIn open={storeState.filter.filterSlideInVisible}>
            <StandardFirstLevelHeader
                onClose={() =>
                    update(store =>
                        FilteredPermitsState.Filter.stateWrite(store, {
                            filterSlideInVisible: false,
                        }),
                    )
                }
                title={filteredPermitsFilterHalfSlideInTexts[language].title()}
            />
            <SlideInBody>
                <ValidDateFilterSelection />
                <PermitTypeFilterSelection />
                <OperatorLoginFilterSelection />
                <IssueDateFilterSelection />
                <TimeLimitFilterSelection />
                <ChannelFilterSelection />
                <CostFilterSelection />
                <StatusFilterSelection />
            </SlideInBody>
        </HalfSlideIn>
    );
}
